import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';

const uploadFileMedia = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.media.upload, payload);
};
const deleteMedia = async (file) => {
    return await HTTP_CLIENT.delete(Endpiont.media.delete + file);
};
export { uploadFileMedia, deleteMedia };
